export const STATUS_LABELS: Record<string, string> = {
    active: 'ใช้งานอยู่',
    inactive: 'ปิดใช้งาน',
    suspended: 'ถูกระงับ',
};

export const ROLE_LABELS: Record<string, string> = {
    admin: 'ผู้ดูแลระบบ',
    staff: 'พนักงาน',
};

export const SUSPEND_REASONS = [
    'ละเมิดข้อกำหนดการใช้งาน',
    'พฤติกรรมทุจริต',
    'สแปม/โฆษณา',
    'ร้องเรียนจากผู้ใช้อื่น',
    'ข้อมูลเท็จ',
    'อื่นๆ',
];
